import React from 'react';
import axios from 'axios';

const imageStyles = {
  maxWidth: "300px",
  marginRight: "5px",
};

class AsyncImage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      image: "",
    };

  }

  componentDidMount() {
    const that = this

    async function getImage() {
      try {
        
        var size_param = ""
        if (that.props.size !== null) size_param = '?size=' + that.props.size;
        const response = await axios.get(process.env.REACT_APP_BACKEND_BASE_URL+ '/projects/'+ that.props.projectId +'/image/'+ that.props.imageId + size_param  , { headers: { 'Authorization': localStorage.getItem("token") }, responseType: 'arraybuffer' });
        // console.log("Image: " + Buffer.from(response.data, 'binary').toString('base64'));

        if (response.status === 200) {
          that.setState({ loaded: true });
          that.setState({ image: Buffer.from(response.data, 'binary').toString('base64') });
          // console.log(response);
        }

        return response
      } catch (error) {
        console.error(error);
      }
    }

    getImage();
  }

  render() {

    return (

      <div>
        {/* <h1> {this.state.image.data} </h1> */}

        {this.state.loaded ? 
          (<img src={"data:image/jpeg;base64," + this.state.image} alt={this.props.imageId} style={imageStyles}/>):(<img src="https://via.placeholder.com/300" style={imageStyles}/>)
        }

      </div>
    )
  }

}

export default AsyncImage;


// WEBPACK FOOTER //
// src/components/innerComponents/AsyncImage.js